import { useFeatureFlag } from 'src/featureFlags'

// The build flag, unless the Remote Config kill switch is on: unset means on, so only an explicit `true` turns Advanced off.
export const useAdvancedEnabled = (): boolean => {
  const killed = useFeatureFlag('featureFlagAdvancedDashboardDisabled')
  return process.env.ADVANCED_DASHBOARD_ENABLED === 'true' && !killed
}
